<button
  class="btn btn-sm btn-block"
  color="primary"
  mat-raised-button
  (click)="googletry()"
  aria-label="Google SignIn"
>
  <img
    src="../../assets/google-icon.svg"
    width="20rem"
    height="auto"
    style="border-radius: 1rem"
  />
  &nbsp; Iniciar Sesión
</button>
